/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var Distance;
(function (Distance) {
    /**
     * Unit, `km` for kilometers, `mi` for miles
     */
    let unit;
    (function (unit) {
        unit["KM"] = "km";
        unit["MI"] = "mi";
    })(unit = Distance.unit || (Distance.unit = {}));
})(Distance || (Distance = {}));
//# sourceMappingURL=Distance.js.map